export default __webpack_public_path__ + "static/media/IMG_3555.ddcde33d.jpg";